import { createContext, FC, ReactElement, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Settings, SettingsContextState } from './types'

export const defaultSettings: Settings = {
  notification__email: '',
  notification__email_enabled: true,
  preference__user_language: 'en_US',
  preference__user_level: 'basic',
  preference__show_annotator_instructions: false,
  preference__show_guided_tour: false,
  preference__show_precision_alert_on_creation: false,
  preference__show_precision_alert_on_download: false,
}

const contextDefaultValues: SettingsContextState = {
  settings: defaultSettings,
  updateSettings: () => undefined,
}

export const SettingsContext = createContext<SettingsContextState>(
  contextDefaultValues
)

type ProviderPorps = {
  children: ReactElement
}

const SettingsProvider: FC<ProviderPorps> = ({ children }) => {
  const { i18n } = useTranslation()
  const [settings, setSettings] = useState<Settings>(defaultSettings)

  const value = useMemo(() => {
    const updateSettings = (newSettings: Partial<Settings>) => {
      // Do custom stuff with newSettings
      if (newSettings.preference__user_language) {
        i18n.changeLanguage(newSettings.preference__user_language)
      }

      // Update the context
      setSettings({ ...settings, ...newSettings })
    }

    return { settings, updateSettings }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings])

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  )
}

export default SettingsProvider
